import React, { Component, PropTypes } from 'react';
import { Assign } from 'containers';
import { AdminScreen, AccessDenied } from 'components';
import { fetch } from 'lib/network/webapi';
import { connect } from 'react-redux';
import * as actions from 'state/modules/assign';
import styles from './Home.css';

/* eslint-disable */
let Manage;
if (__MANAGE__) {
    Manage = require('../Manage/Manage').default;
}

class Home extends Component {
  static propTypes = {
    fetchOwnerId: PropTypes.func,
    ownerId: PropTypes.string,
    activeLocale: PropTypes.string
  }

  state = {
    loadAssignManage: false,
    divCode: '',
    loadAdmin: false,
    loadAccessDenied: false,
    loginUserRecord: {},
    isSystemDown: false
  };

  getChildContext() {
    return {
      currentLanguage: this.props.activeLocale
    };
  }

  loadScreen = (userId) => {
    fetch('systemuser', userId)
    .then((crmResponse) => {
      console.log('crmResponse', crmResponse);
      const loginUserRecord = crmResponse.data.data.result[0];
      console.log('loginUserRecord', loginUserRecord);
      let positionCode = '';
      if (loginUserRecord) {
        positionCode = loginUserRecord.cica_positioncode;
      }
      console.log('positionCode', positionCode);
      if (positionCode === 'LAD' || ((positionCode === '16' || positionCode === 16) && (loginUserRecord.cica_salesforce === '19' || loginUserRecord.cica_salesforce === '18')) || ((positionCode === '18' || positionCode === 18) && loginUserRecord.cica_salesforce === '02')) {
        this.setState({
          loadAssignManage: false,
          loadAdmin: true,
          loadAccessDenied: false,
          divCode: loginUserRecord.cica_divisioncode
        });
      } else if (((positionCode === '04' && (loginUserRecord.cica_salesforce === '19' || loginUserRecord.cica_salesforce === '18')) || ((positionCode === '04' || positionCode === '31' || positionCode === '36') && loginUserRecord.cica_salesforce === '02')) || !loginUserRecord) {
        this.setState({
          loadAssignManage: false,
          loadAdmin: false,
          loadAccessDenied: true
        });
      } else {
        this.setState({
          loadAssignManage: true,
          loadAdmin: false,
          loadAccessDenied: false,
          loginUserRecord
        });
      }
    })
  }

  componentDidMount() {
    if(!__MANAGE__) {
      this.props.fetchOwnerId().then(result => this.loadScreen(result.data.UserId));
    } else {
      this.setState({
        loadAssignManage: true,
        loadAdmin: false,
        loadAccessDenied: false
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!__MANAGE__ && nextProps.ownerId !== this.props.ownerId) {
      nextProps.ownerId ? this.loadScreen(nextProps.ownerId) :
      this.props.fetchOwnerId().then(result => (
        this.loadScreen(result.data.UserId)
      ));
    }
  }

  render() {
    return (
      <div className={styles.toplevelContainer}>
        {!this.state.isSystemDown && this.state.loadAssignManage && (__MANAGE__? <Manage /> : <Assign loginUserRecord={this.state.loginUserRecord}/>)}
        {!this.state.isSystemDown && (this.state.loadAdmin) && <AdminScreen divCode={this.state.divCode} />}
        {(this.state.loadAccessDenied || this.state.isSystemDown) && <AccessDenied isSystemDown={this.state.isSystemDown} />}
      </div>
     );
  }
}

Home.childContextTypes = {
  currentLanguage: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  ownerId: !__MANAGE__ && state.assign.ownerId ? state.assign.ownerId : null,
  activeLocale:  __MANAGE__  ? state.manage.currentLanguage : state.assign.currentLanguage
});

export default connect(mapStateToProps, actions)(Home);



// WEBPACK FOOTER //
// ./src/containers/Home/Home.js